import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ts-auto-mock/ts-auto-mock/ui/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "types-supported"
    }}>{`Types supported`}</h1>
    <p>{`The library tries to convert the type argument passed to createMock so you don't have to mock them manually.`}</p>
    <h2 {...{
      "id": "primitive"
    }}>{`Primitive`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`number // 0
string // ""
boolean // false
boolean[] // []
void // undefined
null // null
undefined // undefined
never // undefined
`}</code></pre>
    <h2 {...{
      "id": "interfaces"
    }}>{`Interfaces`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`interface Person {
  id: string
  name: string
}
/*
{
  id: "",
  name: ""
}
*/
`}</code></pre>
    <h2 {...{
      "id": "interfaces-with-call-signatures"
    }}>{`Interfaces with call signatures`}</h2>
    <p>{`For overload methods it will use the first one`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`interface Person {
  (): number
  (): string
  name: string
}

const mock = createMock<Person>();
mock() // 0
mock.name // ""
`}</code></pre>
    <h2 {...{
      "id": "interfaces-with-construct-signatures"
    }}>{`Interfaces with construct signatures`}</h2>
    <p>{`For overload constructors it will use the first one`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`interface PersonWithHat {
  hatSize: number;
}

interface PersonWithoutHat {
  shirtSize: number;
}

interface Person {
  new (hatSize: number): PersonWithHat
  new (): PersonWithoutHat
  name: string
}

const mock = createMock<Person>();
new mock() // { hatSize: 0 }
mock.name // ""
`}</code></pre>
    <h2 {...{
      "id": "classes"
    }}>{`Classes`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`class Person {
  private _id: string;
  name: string
}
/*
{
  name: ""
}
*/
`}</code></pre>
    <h2 {...{
      "id": "methods"
    }}>{`Methods`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`interface InterfaceWithMethod {
  method(): string
}
/*
{
  method: () => {
    return ""
  }
}
*/
`}</code></pre>
    <h2 {...{
      "id": "literal"
    }}>{`Literal`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`type Data = {
  id: "I am a specific string",
  number: 2
}
/*
{
  id: "I am a specific string",
  number: 2
}
/*
`}</code></pre>
    <h2 {...{
      "id": "enum-it-will-select-the-first-value"
    }}>{`Enum (it will select the first value)`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`enum Direction {
  LEFT,
  RIGHT
}

interface WithEnum {
  direction: Direction
}
/*
{
  direction: DIRECTION.LEFT
}
/*
`}</code></pre>
    <h2 {...{
      "id": "function"
    }}>{`Function`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const mock = createMock<() => string>();
mock // () => ""
`}</code></pre>
    <h2 {...{
      "id": "object"
    }}>{`Object`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const mock = createMock<{ a: string }>();
mock // { a: "" }
`}</code></pre>
    <h2 {...{
      "id": "key-in"
    }}>{`Key in`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`type Keys = "a" | "b";
type myType = { [key in Keys]: string }
const mock = createMock<myType>();
mock // { a: "", b: "" }
`}</code></pre>
    <h2 {...{
      "id": "key-in-keyof"
    }}>{`Key in keyof`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`type Keys = {
    a: number;
}
type keyInKeyof = { [key in keyof Keys]: string }
const mock = createMock<keyInKeyof>();
mock // { a: "" }
`}</code></pre>
    <h2 {...{
      "id": "optional"
    }}>{`Optional`}</h2>
    <p>{`The property is not defined in the mock`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`class MyClass {
    test?: string;
}
const mock = createMock<MyClass>();
mock // { }
`}</code></pre>
    <h2 {...{
      "id": "typescript-libraries-array-number-ecc"
    }}>{`Typescript libraries (Array, Number... ecc)`}</h2>
    <p>{`This is a special case. The library tries to convert to the most useful type.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`class MyClass {
  array: Array<number>; // []
  number: Number; // 0
  promise: Promise<string>; // a promise that will resolve an empty string Promise.resolve("")
  map: Map<string, string>; // new Map()
  set: Set<string>; // new Set()
}
`}</code></pre>
    <h2 {...{
      "id": "tuple"
    }}>{`Tuple`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`class MyClass {
  tuple: [string, number];
}

const mock = createMock<MyClass>();
mock // { tuple: ['', 0] }
`}</code></pre>
    <h2 {...{
      "id": "union"
    }}>{`Union`}</h2>
    <p>{`It will convert to the first type of the union unless undefined/void are part of the union,
in that case it will convert to undefined, being the "smallest type"`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`class MyClass {
  union: string | number;
}

const mock = createMock<MyClass>();
mock // { union: "" }

class MyClass1 {
  union: string | undefined;
}

const mock1 = createMock<MyClass1>();
mock1 // { union: undefined }
`}</code></pre>
    <h2 {...{
      "id": "dictionary"
    }}>{`Dictionary`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`type Dictionary<T> = {
  [key: string]: T;
}

const mock = createMock<Dictionary<Interface>>();
mock // {}
`}</code></pre>
    <h2 {...{
      "id": "extends"
    }}>{`Extends`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`interface Keys {
  a: string;
}
interface Interface extends Keys {
  b: boolean;
}

const mock = createMock<Interface>();
mock // { a: "", b: "" }
`}</code></pre>
    <h2 {...{
      "id": "generics"
    }}>{`Generics`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`interface WithGeneric<T>{
  generic: T
}

const mock = createMock<WithGeneric<string>>();
mock // { generic: "" }
`}</code></pre>
    <h2 {...{
      "id": "intersection"
    }}>{`Intersection`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`interface IntersectionA {
  a: string;
}

interface IntersectionB {
  b: number;
}

interface Interface {
  intersection: IntersectionA & IntersectionB,
}

const mock = createMock<Interface>();
mock // { intersection: { a: "", b: 0 } }
`}</code></pre>
    <h2 {...{
      "id": "constructortype"
    }}>{`ConstructorType`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`interface Test {
  a: string;
}
const mockType = createMock<new () => Test>();
const mock = new mockType();

mock = // { a: "" }
`}</code></pre>
    <h2 {...{
      "id": "typequery"
    }}>{`TypeQuery`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`enum AnEnum {
  a,
  b = 'something',
}

const mock = createMock<typeof AnEnum>();
mock.a // 0
mock.b // 'something'
mock[0] // 'a'

class AClass {
  a: string
}

const mockClass = createMock<typeof AClass>();
new mockClass().a // ''

function AFunction(): number;

const mockFunction = createMock<typeof AFunction>();
mockFunction() // 0
`}</code></pre>
    <h2 {...{
      "id": "indexedaccesstype"
    }}>{`IndexedAccessType`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`class Class {
  a: string
}

type KeyOf = { [key in keyof Class]: Class[key] };
const mock = createMock<KeyOf>();
mock.a // ''
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      